"use strict";

var _createClass = function () {
  function a(e, r) {
    for (var t = 0; t < r.length; t++) {
      var a = r[t];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }

  return function (e, r, t) {
    return r && a(e.prototype, r), t && a(e, t), e;
  };
}();

function _classCallCheck(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, r) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !r || "object" != typeof r && "function" != typeof r ? e : r;
}

function _inherits(e, r) {
  if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function, not " + typeof r);
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
}

var React = require("react"),
    PropTypes = require("prop-types");

function isBefore(e, r) {
  if (e.parentNode == r.parentNode) for (var t = e; t; t = t.previousSibling) {
    if (t === r) return !0;
  }
  return !1;
}

function addOrRemoveClass(e, r, t) {
  t ? e.className.indexOf(r) < 0 && (e.className += " " + r) : e.className = e.className.replace(" " + r, "");
}

var SortableList = function () {
  function t(e) {
    _classCallCheck(this, t);

    var r = _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

    return r.listDOM = React.createRef(), r.source = null, r.onDragStart = r.onDragStart.bind(r), r.onDragOver = r.onDragOver.bind(r), r.onDragLeave = r.onDragLeave.bind(r), r.onDragEnd = r.onDragEnd.bind(r), r.onDrop = r.onDrop.bind(r), r;
  }

  return _inherits(t, React.Component), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this.listDOM.current && (this.listDOM.current.addEventListener("dragstart", this.onDragStart), this.listDOM.current.addEventListener("dragover", this.onDragOver), this.listDOM.current.addEventListener("dragend", this.onDragEnd));
    }
  }, {
    key: "isInList",
    value: function value(e) {
      for (var r = e; r;) {
        if (r === this.listDOM.current) return !0;
        r = r.parentNode;
      }

      return !1;
    }
  }, {
    key: "getListElement",
    value: function value(e) {
      if (!this.isInList(e)) return null;

      for (var r = e; r && "LI" !== r.tagName;) {
        r = r.parentNode;
      }

      return r;
    }
  }, {
    key: "getDragTarget",
    value: function value(e) {
      if (!this.isInList(e.target)) return null;
      var r = this.getListElement(e.target);
      return r === this.source ? null : r;
    }
  }, {
    key: "onDragOver",
    value: function value(e) {
      if (this.source) {
        e.preventDefault();
        var r = this.getDragTarget(e);
        r && (isBefore(this.source, r) ? addOrRemoveClass(r, "blx-dragover-top", !0) : addOrRemoveClass(r, "blx-dragover-bottom", !0));
      }
    }
  }, {
    key: "onDragLeave",
    value: function value(e) {
      if (this.source) {
        var r = this.getDragTarget(e);
        r && (addOrRemoveClass(r, "blx-dragover-top", !1), addOrRemoveClass(r, "blx-dragover-bottom", !1));
      }
    }
  }, {
    key: "onDrop",
    value: function value(e) {
      if (this.source) {
        e.preventDefault();
        var r = this.getDragTarget(e);

        if (r) {
          var t = Array.prototype.slice.call(this.listDOM.current.children),
              a = t.indexOf(this.source);
          isBefore(this.source, r) ? r.parentNode.insertBefore(this.source, r) : r.parentNode.insertBefore(this.source, r.nextSibling), addOrRemoveClass(r, "blx-dragover-top", !1), addOrRemoveClass(r, "blx-dragover-bottom", !1), addOrRemoveClass(this.source, "blx-dragging", !1);
          var n = (t = Array.prototype.slice.call(this.listDOM.current.children)).indexOf(this.source);
          this.props.onDrop(a, n), this.source = null;
        }
      }
    }
  }, {
    key: "onDragStart",
    value: function value(e) {
      0 <= e.target.className.indexOf("blx-icon-drag") && (this.source = e.target.parentNode, this.source.draggable = !0, addOrRemoveClass(this.source, "blx-dragging", !0), e.dataTransfer.effectAllowed = "move", e.dataTransfer.setData("text/html", this.source), e.dataTransfer.setDragImage(this.source, 275, 0));
    }
  }, {
    key: "onDragEnd",
    value: function value(e) {
      this.source && (addOrRemoveClass(this.source, "blx-dragging", !1), this.source = null);
    }
  }, {
    key: "render",
    value: function value() {
      var r = this;
      return React.createElement("ul", {
        style: this.props.style,
        className: "blx-sortable-list " + this.props.className,
        ref: this.listDOM
      }, React.Children.map(this.props.children, function (e) {
        return React.createElement("li", {
          key: Math.random(),
          className: "blx-sortable-list-item",
          onDragLeave: r.onDragLeave,
          onDrop: r.onDrop
        }, e, React.createElement("span", {
          className: "blx-icon blx-icon-drag",
          draggable: "true"
        }));
      }));
    }
  }]), t;
}();

SortableList.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onDrop: PropTypes.func
}, SortableList.defaultProps = {
  className: "",
  style: null,
  onDrop: function onDrop() {}
}, module.exports = SortableList;